// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"141":"history","474":"revew","485":"game","857":"report","884":"admin","966":"login"}[chunkId] || chunkId) + "." + {"141":"b09b1f7c","474":"ea35f7ae","485":"d4e9fea1","652":"765bee69","811":"00b90fb5","857":"7773f154","884":"e8ec80f2","966":"861ed413"}[chunkId] + ".js";
};